import React, { useEffect, useRef } from 'react';

import { usePrimaryColor } from '../../../hooks/usePrimaryColor';

const FaviconChanger: React.FC = () => {
  const svgRef = useRef<SVGSVGElement>(null);
  const primaryColor = usePrimaryColor();
  useEffect(() => {
    if (svgRef.current) {
      const svg = svgRef.current;
      const xml = new XMLSerializer().serializeToString(svg);
      const svg64 = btoa(xml);
      const b64Start = 'data:image/svg+xml;base64,';
      const image64 = b64Start + svg64;

      const link: HTMLLinkElement =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link');
      link.type = 'image/svg+xml';
      link.rel = 'icon';
      link.href = image64;

      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }, [primaryColor]);

  return (
    <div style={{ display: 'none' }}>
      <svg
        ref={svgRef}
        width="17"
        height="21"
        viewBox="0 0 17 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.24219 10.1221C8.79219 10.1221 9.26302 9.92624 9.65469 9.53457C10.0464 9.1429 10.2422 8.67207 10.2422 8.12207C10.2422 7.57207 10.0464 7.10124 9.65469 6.70957C9.26302 6.3179 8.79219 6.12207 8.24219 6.12207C7.69219 6.12207 7.22135 6.3179 6.82969 6.70957C6.43802 7.10124 6.24219 7.57207 6.24219 8.12207C6.24219 8.67207 6.43802 9.1429 6.82969 9.53457C7.22135 9.92624 7.69219 10.1221 8.24219 10.1221ZM8.24219 17.4721C10.2755 15.6054 11.7839 13.9096 12.7672 12.3846C13.7505 10.8596 14.2422 9.5054 14.2422 8.32207C14.2422 6.5054 13.663 5.0179 12.5047 3.85957C11.3464 2.70124 9.92552 2.12207 8.24219 2.12207C6.55885 2.12207 5.13802 2.70124 3.97969 3.85957C2.82135 5.0179 2.24219 6.5054 2.24219 8.32207C2.24219 9.5054 2.73385 10.8596 3.71719 12.3846C4.70052 13.9096 6.20885 15.6054 8.24219 17.4721ZM8.24219 20.1221C5.55885 17.8387 3.55469 15.7179 2.22969 13.7596C0.904688 11.8012 0.242188 9.98874 0.242188 8.32207C0.242188 5.82207 1.04635 3.8304 2.65469 2.34707C4.26302 0.863737 6.12552 0.12207 8.24219 0.12207C10.3589 0.12207 12.2214 0.863737 13.8297 2.34707C15.438 3.8304 16.2422 5.82207 16.2422 8.32207C16.2422 9.98874 15.5797 11.8012 14.2547 13.7596C12.9297 15.7179 10.9255 17.8387 8.24219 20.1221Z"
          fill={primaryColor}
        />
      </svg>
    </div>
  );
};

export default FaviconChanger;
